import { useEffect, useRef } from 'react';
import { registerScene } from '../lib/scene';
import { usePrefersReducedMotion } from './usePrefersReducedMotion';

/**
 * Opts an element into the shared 3D scroll scene. Under reduced motion the
 * element is never registered, so it renders completely flat — the depth is
 * decoration and nothing depends on it.
 */
export function useScrollScene<T extends HTMLElement>(intensity = 1) {
  const ref = useRef<T>(null);
  const reduced = usePrefersReducedMotion();

  useEffect(() => {
    const node = ref.current;
    if (!node || reduced) return;
    return registerScene(node, intensity);
  }, [intensity, reduced]);

  return ref;
}
